import { render, staticRenderFns } from "./PendingOrders.vue?vue&type=template&id=1489a10c&scoped=true&"
import script from "./PendingOrders.vue?vue&type=script&lang=js&"
export * from "./PendingOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1489a10c",
  null
  
)

export default component.exports